const labelValidatorDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require: 'ngModel',
	/**
	 * @param {import('angular').IScope} scope
	 * @param {any} element
	 * @param {import('angular').IAttributes} attributes
	 * @param {any} ctrl
	 */
	link(scope, element, attributes, ctrl) {
		scope.$watch('component.label', () => {
			if (ctrl.$invalid) {
				element[0].parentNode.classList.add('has-warning');
				ctrl.$validate();
			}
			else {
				element[0].parentNode.classList.remove('has-warning');
				ctrl.$validate();
			}
		}, true);
	},
});

export default labelValidatorDirective;
